import React, {useState} from 'react'
import { useLocation, Navigate } from 'react-router-dom';
import SideBar from '../components/sidebar/SideBar';
import NavBar from '../components/nav/PagesNavBar';
import { Heading, InfoContainer, Img, Text, TextWrapper } from '../components/info_section/InfoElems'
import Footer from '../components/footer/Footer';
import styled from 'styled-components';
import {} from '../components/form/FormElems';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ResultsDoc from '../ResultsDoc';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';



const InfoWrapper = styled.div`
    grid-template-columns: 1fr 1fr 1fr;
    display: grid;
    align-content: center;
    justify
    max-width: 1100px;
    background: #479e35;

    @media screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20px;
    }
`

const InfoCard = styled.div`
    display: flex;
    background: #479e35;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    margin: 0 10px 10px 10px;
    transition: all 0.2s ease-in-out;


`

const Subtitle = styled.h1`
    font-size: 3rem;
    color: #fff;

    @media screen and (max-width: 768px) {
        font-size: 2.6rem;
    }

    @media screen and (max-width: 480px) {
        font-size: 2.6rem;
    }
`

const TopLine = styled.p`
    color: #fff;
    font-size: 1rem;
    text-align: center;
    text-transform: uppercase;
    

    @media screen and (max-width: 768px) {
        font-size: 0.9rem;
    }

    @media screen and (max-width: 480px) {
        font-size: 0.9rem;
    }
`

const Btn = styled.button`
    display: block;
    background-color: #c2e8ba;
    color: #000;
    font-size: 0.9rem;
    border: 0;
    height: 40px;
    padding: 0 20px;
    cursor: pointer;
    box-sizing: border-box;
    justify-content: center;

    &:hover {
      transform: scale(1.05);
      transition: all 0.2s ease-in-out;
      background: #fff;
      color: #000;
  }
`

const Results = () => {
    const location = useLocation();
    const data = location.state;
    const [name, setName] = useState(
      data ? data.name : ''
    );
    const [isOpen, setIsOpen] = useState(false);
  
    if(!data) return <Navigate to="/simulator"/>


    const toggle = () => {
    setIsOpen(!isOpen)
    };

    const handleDownload = async (event) => {
        event.preventDefault(); // prevent page reload
        const blob = await pdf(
            <ResultsDoc fields={{
              type: data.type.toUpperCase(),
              name: data.name,
              email: data.email,
              contact: data.contact,
              address: data.address,
              bricks: data.bricks,
              cost: (data.bricks*0.40).toFixed(2),
              emissions: (data.bricks*0.000123).toFixed(3)
          }} />
        ).toBlob();
    
        saveAs(blob, 'WasteWise_results_simulator.pdf');
    };
  
    return (
      <>
      <SideBar isOpen={isOpen} toggle={toggle}/>
      <NavBar toggle={toggle}/>
      <div style={{"height": "60px", "background":"#479e35"}}/>
      <InfoContainer id='mission' color={"#479e35"} height={"200px"}>
          <Heading color='#fff'>Resultados 📋</Heading>
          <div style={{"height": "30px"}}/>
      </InfoContainer>
      <div style={{"background":"#479e35"}}>
      <InfoWrapper>
      <InfoCard>
        <Subtitle>{(data.bricks*0.40).toFixed(2)}€</Subtitle>
        <TopLine>Custo total dos tijolos*</TopLine>
      </InfoCard>
      <InfoCard>
        <Subtitle>2€ /km</Subtitle>
        <TopLine>Custo de transporte*</TopLine>
      </InfoCard>
      <InfoCard>
        <Subtitle>{(data.bricks*0.000123).toFixed(3)*1000} kg</Subtitle>
        <TopLine>Redução das emissões de CO2</TopLine>
      </InfoCard>
      </InfoWrapper>
      </div>
      <InfoContainer id='mission' color={"#479e35"} height={"200px"}>
      <p style={{"color":"#fff", "fontSize":"0.8rem"}}>*acresce IVA à taxa legal em vigor.</p>
      <TextWrapper>
        <Text color='#fff'>Pode guardar estes resultados.<br />
        Pretende guardá-los?</Text>
        <div style={{"display":"flex", "justifyContent":"center", "alignItems":"center"}}>
        <Btn onClick={handleDownload}>GUARDAR</Btn>
        </div>
        </TextWrapper>
      </InfoContainer>
      <Footer />
      </> 
  )
}

export default Results